import { ReactNode } from 'react';

import styled from '@emotion/styled';
import { Flex, GrayColors, typographyStyle } from '@revenuemarket/cds';
import { Typography } from '@revenuemarket/ui';
import {
  createPartnerInfoFromApi,
  getPartnerByHostname,
} from '@revenuemarket/utils/partners/getPartnerByHostname';
import { GetServerSidePropsContext } from 'next';

import SigninForm from '~components/Auth/Signin';
import UnauthenticatedLayout from '~components/ui/layout/UnauthenticatedLayout';
import { usePartners } from '~hooks/usePartners';
import { deserializeAccessToken } from '~utils/auth';

const Container = styled(Flex)`
  max-width: 440px;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start !important;
  }
`;

export default function LoginPage({ host }: { host: string }) {
  // API에서 파트너 정보 가져오기
  const { data: partnersData } = usePartners();
  const partnerMap = partnersData ? createPartnerInfoFromApi(partnersData.partners || []) : [];
  const isPartnerIntro = !!getPartnerByHostname(host, partnerMap);
  return (
    <Container align="flex-start" justify="center" direction="column">
      <Typography
        variant="h1"
        style={{
          ...typographyStyle['24_600'],
          color: GrayColors.gray900,
          marginBottom: '2px',
          display: 'block',
        }}
      >
        {isPartnerIntro ? '로그인하기' : '로그인'}
      </Typography>

      {!isPartnerIntro && (
        <Typography
          variant="h1"
          style={{
            ...typographyStyle['18_400'],
            color: GrayColors.gray600,
            marginBottom: '24px',
          }}
        >
          클로브로 자금관리를 시작하세요
        </Typography>
      )}

      <SigninForm />
    </Container>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const token = context.req.headers.cookie?.split('accessToken=')[1]?.split(';')[0];
  const decodedToken = token ? deserializeAccessToken(token ?? '') : '';
  const tokenExpired = decodedToken
    ? decodedToken.exp && decodedToken.exp < Date.now() / 1000
    : true;
  const host = context.req.headers.host;

  if (token && !tokenExpired) {
    return {
      redirect: {
        permanent: false,
        destination: '/',
      },
    };
  }
  return {
    props: {
      host,
    },
  };
}

LoginPage.getLayout = (node: ReactNode, layoutProps: Record<string, unknown>) => (
  <UnauthenticatedLayout host={layoutProps.host as string | undefined}>
    {node}
  </UnauthenticatedLayout>
);
